const consentPath = /^\/oauth\/consent(?:\?request_id=[\w-]{43})?$/

export function makeMcpOAuthReturn(requestID: string, now = Date.now()): string {
  const path = requestID ? `/oauth/consent?request_id=${requestID}` : '/oauth/consent'
  if (!consentPath.test(path))
    throw new Error('invalid_oauth_return_path')
  return JSON.stringify({ path, expires: now + 600_000 })
}

export function readMcpOAuthReturn(raw: string | null, authenticated: boolean, now = Date.now()): string | null {
  if (!raw || !authenticated)
    return null
  try {
    const pending = JSON.parse(raw)
    if (typeof pending?.path === 'string' && consentPath.test(pending.path)
      && typeof pending.expires === 'number' && pending.expires > now
      && pending.expires <= now + 600_000) {
      return pending.path
    }
  }
  catch { /* Invalid local state cannot authorize a redirect. */ }
  return null
}
